<template>
    <div class="relative" ref="dropdown">
        <button
            @click="toggleDropdown"
            data-testid="grid-toggle"
            :disabled="disabled"
            :title="disabled ? $t('score_grid.checkin_dart_required') : ''"
            class="border-stroke-1 flex h-9 w-9 items-center justify-center border-1 transition-colors disabled:cursor-not-allowed disabled:opacity-40"
            :class="buttonClasses"
        >
            <svg class="size-10" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                <template v-if="mode === 'dart'">
                    <rect x="12" y="12" width="6" height="4" rx="0.5" :fill="iconColor" />
                    <rect x="20" y="12" width="6" height="4" rx="0.5" :fill="iconColor" />
                    <rect x="28" y="12" width="6" height="4" rx="0.5" :fill="iconColor" />
                    <rect x="12" y="18" width="4" height="4" rx="0.5" :fill="iconColor" />
                    <rect x="18" y="18" width="4" height="4" rx="0.5" :fill="iconColor" />
                    <rect x="24" y="18" width="4" height="4" rx="0.5" :fill="iconColor" />
                    <rect x="30" y="18" width="4" height="4" rx="0.5" :fill="iconColor" />
                    <rect x="12" y="24" width="4" height="4" rx="0.5" :fill="iconColor" />
                    <rect x="18" y="24" width="4" height="4" rx="0.5" :fill="iconColor" />
                    <rect x="24" y="24" width="4" height="4" rx="0.5" :fill="iconColor" />
                    <rect x="30" y="24" width="4" height="4" rx="0.5" :fill="iconColor" />
                    <rect x="12" y="30" width="4" height="4" rx="0.5" :fill="iconColor" />
                    <rect x="18" y="30" width="4" height="4" rx="0.5" :fill="iconColor" />
                    <rect x="24" y="30" width="4" height="4" rx="0.5" :fill="iconColor" />
                    <rect x="30" y="30" width="4" height="4" rx="0.5" :fill="iconColor" />
                </template>
                <template v-else>
                    <rect x="15" y="12" width="4" height="4" rx="0.5" :fill="iconColor" />
                    <rect x="21" y="12" width="4" height="4" rx="0.5" :fill="iconColor" />
                    <rect x="27" y="12" width="4" height="4" rx="0.5" :fill="iconColor" />
                    <rect x="15" y="18" width="4" height="4" rx="0.5" :fill="iconColor" />
                    <rect x="21" y="18" width="4" height="4" rx="0.5" :fill="iconColor" />
                    <rect x="27" y="18" width="4" height="4" rx="0.5" :fill="iconColor" />
                    <rect x="15" y="24" width="4" height="4" rx="0.5" :fill="iconColor" />
                    <rect x="21" y="24" width="4" height="4" rx="0.5" :fill="iconColor" />
                    <rect x="27" y="24" width="4" height="4" rx="0.5" :fill="iconColor" />
                    <rect x="21" y="30" width="4" height="4" rx="0.5" :fill="iconColor" />
                </template>
            </svg>
        </button>
    </div>
</template>

<script>
export default {
    name: 'GridToggleButton',
    props: {
        mode: {
            type: String,
            required: true,
            validator: (value) => ['dart', 'total'].includes(value),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['toggle'],
    data() {
        return {
            isOpen: false,
        }
    },
    computed: {
        buttonClasses() {
            if (this.isOpen) {
                return 'bg-white'
            }

            return 'bg-card hover:bg-card-2'
        },
        iconColor() {
            return this.isOpen ? '#141414' : '#ffffff'
        },
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside)
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside)
    },
    methods: {
        toggleDropdown() {
            if (this.disabled) return
            this.selectMode(this.mode === 'dart' ? 'total' : 'dart')
        },
        selectMode(selectedMode) {
            this.isOpen = false
            if (selectedMode !== this.mode) {
                this.$emit('toggle')
            }
        },
        handleClickOutside(event) {
            if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
                this.isOpen = false
            }
        },
    },
}
</script>
